import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Checkbox } from "../ui/checkbox";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Button } from "../ui/button";

const procedimentosBase = ["vistoria in loco", "análise documental", "registro fotográfico", "entrevista técnica"];
const limitacoesBase = ["ausência de ensaios", "restrição de acesso", "tempo reduzido", "documentação incompleta"];

const StepMetodologia = ({ metodologia, onChange, onSave, readOnly }) => {
  const data = metodologia || {};
  const toggleList = (field, value) => {
    const current = data[field] || [];
    const next = current.includes(value) ? current.filter((item) => item !== value) : [...current, value];
    onChange({ ...data, [field]: next });
  };

  return (
    <Card>
      <CardHeader><CardTitle>Metodologia da Investigação</CardTitle></CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label>Procedimentos adotados</Label>
          {procedimentosBase.map((item) => (
            <label key={item} className="flex items-center gap-2 text-sm">
              <Checkbox checked={(data.procedimentos_adotados || []).includes(item)} onCheckedChange={() => toggleList("procedimentos_adotados", item)} disabled={readOnly} />
              {item}
            </label>
          ))}
        </div>
        <div><Label>Narrativa metodológica</Label><Textarea value={data.narrativa_procedimentos || ""} disabled={readOnly} onChange={(e) => onChange({ ...data, narrativa_procedimentos: e.target.value })} /></div>
        <div className="space-y-2">
          <Label>Limitações da investigação</Label>
          {limitacoesBase.map((item) => (
            <label key={item} className="flex items-center gap-2 text-sm">
              <Checkbox checked={(data.limitacoes_investigacao || []).includes(item)} onCheckedChange={() => toggleList("limitacoes_investigacao", item)} disabled={readOnly} />
              {item}
            </label>
          ))}
        </div>
        <div><Label>Descrição das limitações</Label><Textarea value={data.descricao_limitacoes || ""} disabled={readOnly} onChange={(e) => onChange({ ...data, descricao_limitacoes: e.target.value })} /></div>
        <div><Label>Alcance interpretativo</Label><Textarea value={data.alcance_interpretativo || ""} disabled={readOnly} onChange={(e) => onChange({ ...data, alcance_interpretativo: e.target.value })} /></div>
        {!readOnly && <Button onClick={onSave}>Salvar</Button>}
      </CardContent>
    </Card>
  );
};

export default StepMetodologia;
